/* eslint-disable max-len */
import PNFO from 'jlinc-shared/PNFO'

import PathnameRouter from 'lib/PathnameRouter'

import RedirectPage from './pages/RedirectPage'
import PageLoadingPage from './pages/PageLoadingPage'
import DataPage from './pages/DataPage'
import AuthPage from './pages/AuthPage'
import SearchPage from './pages/SearchPage'
import ChatPage from './pages/ChatPage' // TODO: Original One
//import NotificationChatPage from './pages/NotificationChatPage'
import UserProfilePage from './pages/UserProfilePage'
import OrganizationPage from './pages/OrganizationPage'
import OrganizationJoinPage from './pages/OrganizationJoinPage'
import HubsPage from './pages/HubsPage'
import OrganizationFeedPostPage from './pages/OrganizationFeedPostPage'
import SuperAdminPage from './pages/SuperAdminPage'
import QrRedirectPage from './pages/QrRedirectPage'

// Lazy loaded pages
const lazy = loader => PageLoadingPage.forImport(loader)
const HomePage
  = lazy(() => import(/* webpackChunkName: "HomePage" */ './pages/HomePage'))
const SettingsPage
  = lazy(() => import(/* webpackChunkName: "SettingsPage" */ './pages/SettingsPage'))
const SecurityPage
  = lazy(() => import(/* webpackChunkName: "SecurityPage" */ './pages/SecurityPage'))
const ProfileSetupPage
  = lazy(() => import(/* webpackChunkName: "ProfileSetupPage" */ './pages/ProfileSetupPage'))
const OrganizationCreatePage
  = lazy(() => import(/* webpackChunkName: "OrganizationCreatePage" */ './pages/OrganizationCreatePage'))
const ManageNetworksPage
  = lazy(() => import(/* webpackChunkName: "ManageNetworksPage" */ './pages/ManageNetworksPage'))
const FaqPage
  = lazy(() => import(/* webpackChunkName: "FaqPage" */ './pages/FaqPage'))
const ChildSafetyStandardsPage
  = lazy(() => import(/* webpackChunkName: "ChildSafetyStandardsPage" */ './pages/ChildSafetyStandardsPage'))
const PrivacyPolicyPage
  = lazy(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ './pages/PrivacyPolicyPage'))
const AdminDashboardPage
  = lazy(() => import(/* webpackChunkName: "AdminDashboardPage" */ './pages/AdminDashboardPage'))
const SISAInvitePage
  = lazy(() => import(/* webpackChunkName: "sisas" */ './pages/SISAInvitePage'))
const MyDataPage
  = lazy(() => import(/* webpackChunkName: "sisas" */ './pages/MyDataPage'))
const MyDataDefaultsPage
  = lazy(() => import(/* webpackChunkName: "sisas" */ './pages/MyDataDefaultsPage'))
const MySISAsPage
  = lazy(() => import(/* webpackChunkName: "sisas" */ './pages/MySISAsPage'))
const ExternalPage
  = lazy(() => import(/* webpackChunkName: "sisas" */ './pages/ExternalPage'))
const SellerPage
  = lazy(() => import(/* webpackChunkName: "SellerPage" */ './pages/SellerPage'))
const ShoppingCartPage
  = lazy(() => import(/* webpackChunkName: "ShoppingCartPage" */ './pages/ShoppingCartPage'))
const CheckoutPage
  = lazy(() => import(/* webpackChunkName: "CheckoutPage" */ './pages/CheckoutPage'))
const OrdersPage
  = lazy(() => import(/* webpackChunkName: "OrdersPage" */ './pages/OrdersPage'))
const OrderManagementPage
  = lazy(() => import(/* webpackChunkName: "OrderManagementPage" */ './pages/OrderManagementPage'))
const OrderCustomerServicePage
  = lazy(() => import(/* webpackChunkName: "OrderCustomerServicePage" */ './pages/OrderCustomerServicePage'))
const SellerCustomerServicePage
  = lazy(() => import(/* webpackChunkName: "SellerCustomerServicePage" */ './pages/SellerCustomerServicePage'))
const MySupportPage
  = lazy(() => import(/* webpackChunkName: "MySupportPage" */ './pages/MySupportPage'))
const VideoCallPage
  = lazy(() => import(/* webpackChunkName: "VideoCallPage" */ './pages/VideoCallPage'))
const AdminQrCodesPage
  = lazy(() => import(/* webpackChunkName: "AdminQrCodesPage" */ './pages/AdminQrCodesPage'))
const ServerConnectionPage
  = lazy(() => import(/* webpackChunkName: "ServerConnectionPage" */ './pages/ServerConnectionPage'))


// Page Options
// const requireNotLoggedIn = true
const requireLoggedIn = true
// const noLayout = true

export default new PathnameRouter(map => {
  map('/__data', DataPage, {})
  map('/admin/dashboard', AdminDashboardPage, { requireLoggedIn })
  map('/admin/qr-codes',  AdminQrCodesPage,   { requireLoggedIn })

  // QR code redirect — must be before the /:organizationApikey catch-all
  map('/q/:code', QrRedirectPage, {})

  map('/regauth/:inviteToken', SISAInvitePage, {})
  map('/', isDataYogi ? RedirectPage.redirectTo(`/${PNFO.plural}`) : HomePage)
  map(`/${PNFO.singular}/new/:path*`, OrganizationCreatePage, {requireLoggedIn})
  map('/manage-networks', ManageNetworksPage, {requireLoggedIn})
  map(`/${PNFO.plural}/(subscriber|all|favorites)?`, HubsPage, {})
  map('/superadmin',                           SuperAdminPage, {})

  map(`/search/:searchQuery`, SearchPage, {})
  map(`/search/(${PNFO.plural}|members|posts)/:searchQuery`, SearchPage, {})

  map('/(login|logout|signup|join)',                        AuthPage,                    {})
  map('/:organizationApikey/join/:inviteToken?',            OrganizationJoinPage,        {})
  map('/faq',                                               FaqPage,                     {})
  map('/child-safety-standards',                            ChildSafetyStandardsPage,    {})
  map('/privacy',                                           PrivacyPolicyPage,           {})
  map('/chat/:path*',                                              ChatPage,                    {requireLoggedIn})// the original one
  //map('/chat',                                              NotificationChatPage,                    {requireLoggedIn})
  map('/my-data',                                           MyDataPage,                  {requireLoggedIn})
  map('/my-data/defaults',                                  MyDataDefaultsPage,          {requireLoggedIn})
  map('/my-data/sisas',                                     MySISAsPage,                 {requireLoggedIn})
  map('/profile/edit',                                       ProfileSetupPage,            {requireLoggedIn})
  map('/settings',                                          SettingsPage,                {requireLoggedIn})
  map('/security',                                          SecurityPage,                {requireLoggedIn})
  map('/create/server-connection',                           ServerConnectionPage,        {requireLoggedIn})
  map('/external',                                          ExternalPage,                {})
  map('/seller/connect',                                    SellerPage,           {requireLoggedIn})
  map('/seller/orders',                                     OrderManagementPage,         {requireLoggedIn})
  map('/seller/customer-service/:orderNumber',             SellerCustomerServicePage,   {requireLoggedIn})
  map('/orders/customer-service/:orderNumber?',               OrderCustomerServicePage,   {requireLoggedIn})
  map('/my-support',                                        MySupportPage,               {requireLoggedIn})
  map('/video-call/:roomId',                                VideoCallPage,               {requireLoggedIn})
  map('/cart',                                              ShoppingCartPage,            {requireLoggedIn})
  map('/checkout/:path*',                                    CheckoutPage,                {requireLoggedIn})
  map('/orders/:path*',                                            OrdersPage,                  {requireLoggedIn})
  map('/@:username',                                        UserProfilePage,             {})
  map('/@:username/:path*',                                 UserProfilePage,             {})
  map('/:organizationApikey',                               OrganizationPage,            {})
  map('/:organizationApikey/published/:feedPostUid',        OrganizationFeedPostPage,    {})
  map('/:organizationApikey/:path*',                        OrganizationPage,            {})
})
